import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { WellnessComponent } from './wellness.component';
import { WellnessRoutingModule } from './wellness.routing.module';
import { SharedModule } from '../shared/shared.module';
import { HealthMeasureComponent } from './health-measure/health-measure.component';
import { MaterialModule } from '../shared/material/material.module';
import { LabResultsComponent } from './lab-results/lab-results.component';
import { LifestyleComponent } from './lifestyle/lifestyle.component';
import { AddImmunizationComponent } from './add-immunization/add-immunization.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeleteImmunizationComponent } from './delete-immunization/delete-immunization.component';
import { ScrollToModule } from '@hkjeffchan/ngx-scroll-to';
import { HealthRecordModule } from '../health-record/health-record.module';
import { ConsentOnlyFormComponent } from './vax-pass/vax-pass-card/consent-only-form/consent-only-form.component';

@NgModule({
	imports: [
		CommonModule,
		WellnessRoutingModule,
		SharedModule,
		MaterialModule,
		FormsModule,
		ScrollToModule.forRoot(),
		ReactiveFormsModule,
		HealthRecordModule,
	],
	declarations: [
		WellnessComponent,
		HealthMeasureComponent,
		LabResultsComponent,
		LifestyleComponent,
		AddImmunizationComponent,
		DeleteImmunizationComponent,
		LifestyleComponent,
		ConsentOnlyFormComponent,
	],
	providers: [DatePipe, { provide: MAT_DIALOG_DATA, useValue: {} }, { provide: MatDialogRef, useValue: {} }],
})
export class WellnessModule {}
